'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Label2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-label/build/index.js
// module id = 272
// module chunks = 0